import {SET_CURRENT_USER} from './index';

export function setCurrentUser(user) {
  return {
    type: SET_CURRENT_USER,
    value: user,
  };
}
